import styled from '@emotion/styled'

// Disabled inputs never dispatch click/change events, so this transparent
// overlay is what actually catches the click to open the upgrade modal.
export const UpsellOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
`
